/* Teles Samsung (Tizen): el navegador de la tele no entrega al reproductor las teclas de multimedia y de canal si la app no las
   «registra» antes (tizen.tvinputdevice). Se registran las que usa el reproductor; sin Tizen (otro navegador, otra tele) no hace nada.
   Códigos de las teclas del mando Samsung: 415 play, 19 pausa, 10252 play/pausa, 413 stop, 417 avance, 412 retroceso,
   427 canal +, 428 canal −; «atrás» (10009) y los números ya llegan siempre. */

export const TIZEN_KEYS = ['MediaPlay', 'MediaPause', 'MediaPlayPause', 'MediaStop', 'MediaFastForward', 'MediaRewind', 'ChannelUp', 'ChannelDown', 'ColorF0Red', 'ColorF1Green', 'ColorF2Yellow', 'ColorF3Blue', 'Info', 'Guide'];

export function initTizen(win = typeof window !== 'undefined' ? window : null) {
    const tz = win && win.tizen;
    if (!tz || !tz.tvinputdevice || typeof tz.tvinputdevice.registerKey !== 'function') return [];
    const done = [];
    TIZEN_KEYS.forEach((k) => {
        try { tz.tvinputdevice.registerKey(k); done.push(k); } catch (e) { /* esta tele no tiene esa tecla */ }
    });
    return done;
}
